export default { sha: 'bfb804927e19b01b36696a18f082760a988290b0', buildNumber: 'undefined' }
